import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/course-access-methods/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const courseAccessMethods = {
  getAll: apiPathFunc(pathBase),
} as const;
